import { FetchDefaultProductSettingsRoutine } from '../redux-routines';

export const initialState = {
  isFetching: false,
  data: {},
  error: null
};

export const defaultProductSettingsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FetchDefaultProductSettingsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchDefaultProductSettingsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: {
          ...state.data,
          ...action.payload
        },
        error: null
      };
    case FetchDefaultProductSettingsRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};
